module.exports = __webpack_public_path__ + "media/category_icons/Psychology-515db908.svg";